import React, { Component } from 'react';
import { I18nextProvider } from 'react-i18next';
import store from './store';
import { Provider } from 'react-redux';
import {
  i18n,
  SetLogoutFunction,
  SetResetAppStateFunction,
} from 'fitbeat.react-native-components';
import iconFont from 'react-native-vector-icons/Fonts/Ionicons.ttf';
import fontAwesomeIconFont from 'react-native-vector-icons/Fonts/FontAwesome.ttf';
import evilIconFont from 'react-native-vector-icons/Fonts/EvilIcons.ttf';
import { RootSiblingParent as RootSiblingParentForToasts } from 'react-native-root-siblings';
import AppNavigator from './Navigators/MainAppNavigator';
import './stylesheets/main.scss';
import LogoutFunction from './LogoutFunction';
const iconFontStyles = `
  @font-face {
    src: url(${iconFont});
    font-family: Ionicons;
  }
  @font-face {
    src: url(${evilIconFont});
    font-family: EvilIcons;
   }
  @font-face {
    src: url(${fontAwesomeIconFont});
    font-family: FontAwesome;
  }`;
fetch = window.fetch.bind(window);
// Create stylesheet
const style = document.createElement('style');
style.type = 'text/css';
if (style.styleSheet) {
  style.styleSheet.cssText = iconFontStyles;
} else {
  style.appendChild(document.createTextNode(iconFontStyles));
}

document.head.appendChild(style);
SetLogoutFunction(store.dispatch, LogoutFunction);
SetResetAppStateFunction(store.dispatch);

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <RootSiblingParentForToasts>
            <AppNavigator uriPrefix={APPLICATION_FULL_URL} />
          </RootSiblingParentForToasts>
        </I18nextProvider>
      </Provider>
    );
  }
}

export default App;
